var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.c56730794aec7efdb71b4b6c99ac9396.svg#h';
                    var viewUrl = 'sprites.c56730794aec7efdb71b4b6c99ac9396.svg#view-h';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 18 14',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };